import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'input',
    'value',
    'valueDisplay',
    'validValue',
    'invalidValue',
  ]

  connect() {
    this.render()
  }

  render() {
    let x = parseFloat(this.inputTarget.value)
    let max = parseFloat(this.inputTarget.max)
    let min = parseFloat(this.inputTarget.min)
    let step = parseFloat(this.inputTarget.step)
    let perc =
      (x - (min - 1) - this.inputTarget.step) /
      (max - (min - 1) - this.inputTarget.step)
    let centerX = ($(this.element).width() - 32) * perc

    if (this.hasValidValueTarget) {
      if (x == max) {
        $(this.validValueTarget).hide()
        $(this.invalidValueTarget).show()
      } else {
        $(this.validValueTarget).show()
        $(this.invalidValueTarget).hide()
      }
    }

    // enforced min/max
    var enforcedMax = $(this.inputTarget).data('enforced-max')
    var enforcedMin = $(this.inputTarget).data('enforced-min')
    if (!!enforcedMax && parseFloat(enforcedMax) < this.inputTarget.value) {
      $('.range-tooltip-content').addClass('opacity-50')
    } else if (
      !!enforcedMin &&
      this.inputTarget.value < parseFloat(enforcedMin)
    ) {
      $('.range-tooltip-content').addClass('opacity-50')
    } else {
      $('.range-tooltip-content').removeClass('opacity-50')
    }

    this.valueDisplayTarget.innerHTML = x

    if (this.hasValueTarget) {
      let valueTarget = $(this.valueTarget)
      valueTarget.css('left', centerX - valueTarget.width() / 2 + 16 + 'px')
      valueTarget.show()
    }
  }
}
